/** Query keys for the FINTEL right panel (Delta: Claims/Timeline, and Gaps). */
export const FINTEL_SEARCH_PARAM_KEYS = {
    BASELINE: 'fintelBaselineDate',
    ENTITY: 'fintelEntity',
    MODAL_OPEN: 'fintelModal',
    STORY: 'fintelStory',
    SEGMENT: 'fintelSegment',
    /** Active panel tab: claims | timeline | gaps */
    TAB: 'fintelTab',
    /** Gap id or gapNumber when fintelTab=gaps */
    GAP: 'gap',
};

/** @deprecated Use FINTEL_SEARCH_PARAM_KEYS */
export const DELTA_SEARCH_PARAM_KEYS = FINTEL_SEARCH_PARAM_KEYS;

const LEGACY_SEARCH_PARAM_KEYS = {
    BASELINE: 'deltaBaselineDate',
    ENTITY: 'deltaEntity',
    MODAL_OPEN: 'deltaModal',
    STORY: 'deltaStory',
    SEGMENT: 'deltaSegment',
    TAB: 'deltaTab',
    GAP: 'deltaGap',
};

const LEGACY_KEY_BY_CURRENT = Object.fromEntries(
    Object.keys(FINTEL_SEARCH_PARAM_KEYS).map((field) => [
        FINTEL_SEARCH_PARAM_KEYS[field],
        LEGACY_SEARCH_PARAM_KEYS[field],
    ])
);

/** Read a FINTEL panel param, falling back to legacy delta* names in old URLs. */
export function getFintelSearchParam(searchParams, field) {
    const key = FINTEL_SEARCH_PARAM_KEYS[field];
    const value = searchParams.get(key);
    if (value != null) return value;
    const legacyKey = LEGACY_SEARCH_PARAM_KEYS[field];
    return legacyKey ? searchParams.get(legacyKey) : null;
}

export function applyFintelSearchParamUpdates(prevSearchParams, updates) {
    const next = new URLSearchParams(prevSearchParams);
    let changed = false;

    Object.entries(updates).forEach(([key, value]) => {
        const legacyKey = LEGACY_KEY_BY_CURRENT[key];
        const currentValue = next.get(key);

        if (value === null || value === undefined || value === '') {
            if (currentValue !== null) {
                next.delete(key);
                changed = true;
            }
            if (legacyKey && next.has(legacyKey)) {
                next.delete(legacyKey);
                changed = true;
            }
            return;
        }

        const nextValue = String(value);
        if (currentValue !== nextValue) {
            next.set(key, nextValue);
            changed = true;
        }
        if (legacyKey && next.has(legacyKey)) {
            next.delete(legacyKey);
            changed = true;
        }
    });

    return changed ? next : prevSearchParams;
}

/** @deprecated Use applyFintelSearchParamUpdates */
export const applyDeltaSearchParamUpdates = applyFintelSearchParamUpdates;
